export default __webpack_public_path__ + "static/media/post-07-detail.9115ad05.jpg";